import Head from 'next/head';
import { get_ } from 'sf-modules';

const RichContent = ({ product, catalogPrice }) => {
    const priceToPayPerUnit =
        catalogPrice?.discountedPrice < catalogPrice?.price
            ? catalogPrice?.discountedPrice
            : catalogPrice?.price;

    const priceValidUntilNextYear = new Date();
    priceValidUntilNextYear.setFullYear(priceValidUntilNextYear.getFullYear() + 1);

    const productSchemaMarkup = {
        __html: JSON.stringify({
            '@context': 'https://schema.org/',
            '@type': 'Product',
            name: product.name,
            image: product.images?.map((x) => x.url) || [],
            description: product.seoDescription,
            sku: product.sku,
            gtin: product.gtin,
            url: product.href ? `${process.env.NEXT_PUBLIC_URL}${product.href}` : null,
            brand: {
                '@type': 'Brand',
                name: product.brand,
            },
            ...(!!product?.reviews?.items?.length
                ? {
                      review: product?.reviews?.items?.map((x) => ({
                          '@type': 'Review',
                          reviewRating: {
                              '@type': 'Rating',
                              ratingValue: x.rating,
                              worstRating: '1',
                              bestRating: '5',
                          },
                          name: x.title,
                          author: {
                              '@type': 'Person',
                              name: x.reviewerName,
                              datePublished: new Date(x.created).toISOString(),
                          },
                          reviewBody: x.content,
                      })),
                  }
                : {}),
            ...(get_(product, ['reviews', 'count'], 0) > 0
                ? {
                      aggregateRating: {
                          '@type': 'AggregateRating',
                          ratingValue: product.reviews.average,
                          reviewCount: product.reviews.count,
                          ratingCount: product.reviews.count,
                          worstRating: '1',
                          bestRating: '5',
                      },
                  }
                : {}),
            offers: {
                '@type': 'Offer',
                url: product.href ? `${process.env.NEXT_PUBLIC_URL}${product.href}` : null,
                priceCurrency: 'MXN',
                price: priceToPayPerUnit,
                priceValidUntil: catalogPrice?.discountValidUntil
                    ? catalogPrice?.discountValidUntil
                    : priceValidUntilNextYear,
                availability:
                    product.itemStatus === 'INACTIVE'
                        ? 'https://schema.org/OutOfStock'
                        : 'https://schema.org/InStock',
            },
        }),
    };

    // Cannot use here next/script since embedded script should change on client navigation (does not work with next/script)
    return (
        <Head>
            <script
                id={`product-schema-${product.sku}`}
                type='application/ld+json'
                dangerouslySetInnerHTML={productSchemaMarkup}
            />
        </Head>
    );
};

export default RichContent;
